<template>
    <!-- 城市-汇付账户-充值记录对话框 -->
    <el-dialog title="充值记录" :visible.sync="show" :before-close="closeDialog" width="80%">
        <div style="width: 95%; margin: 0 auto" v-loading="loading">
            <div>
                <div class="handle-box-search">
                    <div class="handle-box">
                        <el-row class="head-search">
                            <el-col :span="12">
                                <span>充值类型: </span>
                                <el-select
                                    style="width: 340px"
                                    v-model="search_data_children.income_type"
                                    placeholder="请选择"
                                    clearable
                                    @keyup.enter.native="recordInit"
                                >
                                    <el-option label="活动金" value="0"> </el-option>
                                    <el-option label="司机服务费" value="1"> </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="12">
                                <span> 操作时间: </span>
                                <el-date-picker
                                    v-model="search_time"
                                    type="datetimerange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    align="right"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    @change="timeChange"
                                    style="margin-bottom: 20px; margin-right: 20px; width: 340px"
                                >
                                </el-date-picker>
                            </el-col>
                        </el-row>
                    </div>
                    <el-button type="primary" @click="searchIncomeLog">搜索</el-button>
                    <el-button  @click="closeDialog">关闭</el-button>
                </div>
            </div>

            <!-- 表格 -->
            <el-table :data="tableData" max-height="500" ref="multipleTable" header-cell-class-name="table-header">
                <el-table-column prop="amount" label="支付金额"> </el-table-column>
                <el-table-column prop="fee_amt" label="手续费"> </el-table-column>

                <el-table-column prop="time_stamp" label="创建时间"> </el-table-column>

                <el-table-column prop="status" label="状态"> </el-table-column>

                <el-table-column prop="fail_reason" label="描述"> </el-table-column>

                <el-table-column prop="req_seq_id" label="流水号"> </el-table-column>

                <el-table-column prop="income_type" label="账户类型"> </el-table-column>
                <el-table-column prop="mode" label="账本模式"> </el-table-column>
                <el-table-column prop="pay_time_stamp" label="支付时间"> </el-table-column>
                <el-table-column prop="admin_code" label="管理员编码"> </el-table-column>
                <el-table-column prop="admin_name" label="管理员姓名"> </el-table-column>
            </el-table>

            <!-- element ui 原生分页组件 -->
            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="search_data_children.page"
                    :page-sizes="[10, 20, 30, 40, 50]"
                    :page-size="search_data_children.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="result_data.count"
                >
                </el-pagination>
            </div>
        </div>
    </el-dialog>
</template>

<script>
var _this;

export default {
    props: {
        isShow: Boolean,
        data: ''
    },

    components: {},
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
            _this.searchIncomeLog();
        }
    },
    data() {
        return {
            show: false,
            loading: true,
            tableData: [],
            result_data: [],
            search_time: '',

            //翻页数据
            search_data_children: {
                page: 1,
                limit: 10,
                income_type: '',

                time_fixed_array: ''
            },

            search_rules_children: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
    },
    methods: {
        // 查询时间
        timeChange(val) {

            if (val != null) {
                _this.search_data_children.time_fixed_array = ['between'].concat(val);
            } else {
                _this.search_data_children.time_fixed_array = '';
            }
        },

        // 搜索
        searchIncomeLog() {
            _this.search_data_children.page = 1;

            _this.incomeLog();
        },

        // 获取列表数据
        incomeLog() {
            _this
                .$post('/huifu/incomeLog', _this.search_data_children, _this.search_rules_children)
                .then((res) => {
                    // 将获取到的数据赋值
                    _this.loading = false;

                    _this.tableData = res.data;
                    _this.result_data = res;
                })
                .catch((err) => {});
        },

        //下拉条（每页显示多少数据）变化
        handleSizeChange(val) {
            _this.search_data_children.limit = val;

            //初始化列表
            _this.incomeLog();
        },
        //页码变化
        handleCurrentChange(val) {
            _this.search_data_children.page = val;

            //初始化列表
            _this.incomeLog();
        },

        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.tableData = [];
            _this.loading = true;

            _this.result_data = [];

            _this.search_data_children = {
                page: 1,
                limit: 10,
                income_type: '',
                time_fixed_array: ''
            };
        }
    }
};
</script>

<style scoped>
.search_style {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
}
.driver_water {
    color: #606266;
    margin-bottom: 20px;
}
.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

.el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}

.avatar-uploader {
    width: 100px;
    height: 100px;
}

.capital-title {
    border-bottom: 1px solid rgb(238, 238, 238);
    padding-bottom: 10px;
    margin-bottom: 10px;
}

h2 {
    font-family: Microsoft YaHei;
    font-weight: 600;
    line-height: 21px;
    color: #222;
    font-size: 18px;
    margin-bottom: 20px;
}

.text {
    border-bottom: 1px solid rgb(238, 238, 238);
    padding-bottom: 10px;
    margin-bottom: 10px;
}

.text > span {
    margin-right: 10px;
}
.money-box {
    display: flex;
    justify-content: space-around;
    margin-bottom: 20px;
}
.money {
    margin-left: 5px;
}
.orange {
    color: rgb(255, 149, 11);
    font-weight: 600;
}
</style>
<style>
.edit-driver .el-tabs__item.is-top.is-active {
    border: 0 !important;
}
.el-date-range-picker__time-header {
    display: block;
}
</style>




